import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {IAlertModel} from "@shared/models/alerts/alerts.model";
import {Icon} from "@types-custom/models/ui/icon-model";

export enum TOAST_STATES  {
  SUCCESS   = 'toast-success',
  WARNING   = 'toast-warning',
  DANGER    = 'toast-danger'
}

export enum TOAST_ICONS  {
  AIRQUALITY   = 'AirIconNotify',
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public showsToast$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public toastMessage$: BehaviorSubject<IAlertModel> = new BehaviorSubject<IAlertModel>(null);
  public toastState$: BehaviorSubject<string> = new BehaviorSubject<string>(TOAST_STATES.SUCCESS);

  public isComponentVisible$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  public showToast(toastState: string, toastMsg: IAlertModel): void {
    this.toastState$.next(toastState);
    this.toastMessage$.next(toastMsg);
    this.showsToast$.next(true);
  }

  public dismissToast(): void {
    this.showsToast$.next(false);
  }
}
